module.exports = __webpack_public_path__ + "svgs/coupon-0.e0648227.svg";